import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';

const GearDeskVisual = () => (
  <Box sx={{ position: 'relative', height: { xs: 300, md: 400 } }}>
    <Box sx={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 60% 50%, rgba(99,102,241,0.08) 0%, transparent 70%)', borderRadius: '20px' }} />
    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '92%' }}>
      <Box sx={{ bgcolor: '#FFFFFF', borderRadius: '14px', border: '1px solid rgba(0,0,0,0.08)', overflow: 'hidden', boxShadow: '0 24px 60px rgba(99,102,241,0.1), 0 4px 16px rgba(0,0,0,0.06)' }}>
        <Box sx={{ bgcolor: '#F3F4F6', px: 2, py: 1, display: 'flex', gap: 1, alignItems: 'center', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#FF5F57' }} />
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#FFBD2E' }} />
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#28C840' }} />
          <Typography sx={{ ml: 1, fontSize: '0.62rem', color: '#9CA3AF' }}>GearDesk — Support Tickets</Typography>
        </Box>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
          {[
            { id: 'GD-1042', customer: 'Acme Corp', issue: 'Unit overheating on startup', status: 'In Progress', pct: 65, color: '#6366F1', bg: '#EEF2FF' },
            { id: 'GD-1041', customer: 'BuildRight Ltd', issue: 'Firmware update failed', status: 'Resolved', pct: 100, color: '#16A34A', bg: '#F0FDF4' },
            { id: 'GD-1040', customer: 'TechFlow Sdn Bhd', issue: 'Sensor calibration error', status: 'Pending', pct: 10, color: '#D97706', bg: '#FFFBEB' },
          ].map((t) => (
            <Box key={t.id} sx={{ bgcolor: '#F9FAFB', borderRadius: '8px', p: 1.5, border: '1px solid rgba(0,0,0,0.05)' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
                <Box>
                  <Typography sx={{ fontSize: '0.6rem', color: '#6366F1', fontWeight: 700 }}>{t.id}</Typography>
                  <Typography sx={{ fontSize: '0.7rem', color: '#111827', fontWeight: 600 }}>{t.customer}</Typography>
                  <Typography sx={{ fontSize: '0.6rem', color: '#9CA3AF' }}>{t.issue}</Typography>
                </Box>
                <Box sx={{ px: 1, py: 0.3, borderRadius: '4px', bgcolor: t.bg, height: 'fit-content' }}>
                  <Typography sx={{ fontSize: '0.55rem', color: t.color, fontWeight: 700 }}>{t.status}</Typography>
                </Box>
              </Box>
              <Box sx={{ height: 3, bgcolor: '#E5E7EB', borderRadius: 2 }}>
                <Box sx={{ height: '100%', width: `${t.pct}%`, borderRadius: 2, bgcolor: t.color }} />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </Box>
);

const LineDeskVisual = () => (
  <Box sx={{ position: 'relative', height: { xs: 300, md: 400 } }}>
    <Box sx={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 40% 50%, rgba(99,102,241,0.07) 0%, transparent 70%)', borderRadius: '20px' }} />
    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '92%' }}>
      <Box sx={{ bgcolor: '#FFFFFF', borderRadius: '14px', border: '1px solid rgba(0,0,0,0.08)', overflow: 'hidden', boxShadow: '0 24px 60px rgba(99,102,241,0.1), 0 4px 16px rgba(0,0,0,0.06)' }}>
        <Box sx={{ bgcolor: '#F3F4F6', px: 2, py: 1, display: 'flex', gap: 1, alignItems: 'center', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#FF5F57' }} />
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#FFBD2E' }} />
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#28C840' }} />
          <Typography sx={{ ml: 1, fontSize: '0.62rem', color: '#9CA3AF' }}>LineDesk — Product Records</Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 1, mb: 1.5 }}>
            {[{ l: 'Total Products', v: '1,284', c: '#6366F1', bg: '#EEF2FF' }, { l: 'Under Warranty', v: '847', c: '#16A34A', bg: '#F0FDF4' }, { l: 'Service Due', v: '23', c: '#D97706', bg: '#FFFBEB' }].map(s => (
              <Box key={s.l} sx={{ bgcolor: s.bg, borderRadius: '8px', p: 1.2, textAlign: 'center' }}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 800, color: s.c }}>{s.v}</Typography>
                <Typography sx={{ fontSize: '0.55rem', color: '#6B7280' }}>{s.l}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={{ bgcolor: '#F9FAFB', borderRadius: '8px', p: 1.5, border: '1px solid rgba(0,0,0,0.05)' }}>
            <Box sx={{ bgcolor: '#EEF2FF', borderRadius: '6px', height: 24, display: 'flex', alignItems: 'center', px: 1.5, mb: 1 }}>
              <Typography sx={{ fontSize: '0.6rem', color: '#9CA3AF' }}>🔍  Search products, SKUs, warranties...</Typography>
            </Box>
            {[
              { sku: 'LD-4421', name: 'Motor Unit A3', warranty: 'Valid · Dec 2025', ok: true },
              { sku: 'LD-4420', name: 'Pump Assembly B7', warranty: 'Expired', ok: false },
              { sku: 'LD-4419', name: 'Control Board C1', warranty: 'Valid · Mar 2026', ok: true },
            ].map(p => (
              <Box key={p.sku} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.75, borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
                <Box>
                  <Typography sx={{ fontSize: '0.6rem', color: '#6366F1', fontWeight: 700 }}>{p.sku}</Typography>
                  <Typography sx={{ fontSize: '0.65rem', color: '#111827' }}>{p.name}</Typography>
                </Box>
                <Typography sx={{ fontSize: '0.58rem', color: p.ok ? '#16A34A' : '#DC2626', alignSelf: 'center', fontWeight: 600 }}>{p.warranty}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

const solutions = [
  {
    tag: 'For Manufacturers & Product Companies',
    title: 'GearDesk',
    headline: 'Stop losing customer issues in email chains and WhatsApp groups.',
    description: 'GearDesk is a purpose-built support ticketing system for manufacturers. Customers raise tickets for product issues, engineers get auto-assigned, and the entire support cycle is managed end-to-end — with real-time chat, notifications, file uploads, and analytics.',
    features: ['Customer self-service ticket portal', 'Auto engineer assignment', 'Real-time chat on tickets', 'Instant notifications at every stage', 'File & evidence uploads', 'Full audit log & change history', 'Analytics & resolution reporting', 'Admin dashboard & escalation', 'Custom branding & white-label', 'Custom domain support', 'Self-hosting available'],
    link: '/geardesk',
    visual: <GearDeskVisual />,
    reverse: false,
  },
  {
    tag: 'For Manufacturers & Service Centers',
    title: 'LineDesk',
    headline: 'Your product records deserve better than a spreadsheet.',
    description: 'LineDesk replaces the Excel files and paper logs your production team relies on with a clean, searchable digital system. Find any product, warranty, or service record in seconds.',
    features: ['Digital product database', 'Warranty lifecycle tracking', 'Quality control logs', 'Instant search & filters', 'Service history per unit', 'Custom branding & white-label', 'Custom domain support', 'Self-hosting available'],
    link: '/linedesk',
    visual: <LineDeskVisual />,
    reverse: true,
  },
];

const Solutions = () => {
  const navigate = useNavigate();
  return (
    <Box id="solutions" sx={{ bgcolor: '#FFFFFF' }}>
      <Container maxWidth="lg" sx={{ pt: { xs: 7, md: 12 }, pb: { xs: 6, md: 8 }, px: { xs: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 3 }}>
          <Box>
            <Typography sx={{ color: '#6366F1', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.12em', textTransform: 'uppercase', mb: 1.5 }}>Our Products</Typography>
            <Typography sx={{ fontWeight: 900, color: '#0F1117', fontSize: { xs: '2.2rem', md: '3rem' }, lineHeight: 1.1, letterSpacing: '-0.02em' }}>
              Built for real<br />business problems.
            </Typography>
          </Box>
          <Typography sx={{ color: '#6B7280', maxWidth: 340, lineHeight: 1.8, fontSize: '0.95rem' }}>
            Two SaaS platforms designed from the ground up for SMEs — not adapted from enterprise tools.
          </Typography>
        </Box>
      </Container>

      {solutions.map((s, i) => (
        <Box key={s.title} sx={{ py: { xs: 6, md: 10 }, bgcolor: i % 2 === 0 ? '#FFFFFF' : '#F8F9FF', borderTop: '1px solid #F3F4F6' }}>
          <Container maxWidth="lg">
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: { xs: 6, md: 10 }, alignItems: 'center', direction: s.reverse ? 'rtl' : 'ltr' }}>
              <Box sx={{ direction: 'ltr' }}>
                <Box sx={{ display: 'inline-block', bgcolor: '#EEF2FF', border: '1px solid #C7D2FE', borderRadius: '100px', px: 2, py: 0.6, mb: 3 }}>
                  <Typography sx={{ color: '#4F46E5', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>{s.tag}</Typography>
                </Box>
                <Typography sx={{ fontWeight: 900, color: '#0F1117', fontSize: { xs: '2rem', md: '2.6rem' }, lineHeight: 1.1, letterSpacing: '-0.02em', mb: 1.5 }}>
                  {s.title}
                </Typography>
                <Typography sx={{ color: '#6366F1', fontWeight: 700, fontSize: '1rem', mb: 2.5 }}>{s.headline}</Typography>
                <Typography sx={{ color: '#6B7280', lineHeight: 1.85, mb: 4, fontSize: '0.95rem' }}>{s.description}</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2, mb: 4 }}>
                  {s.features.map((f) => (
                    <Box key={f} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: '#EEF2FF', border: '1px solid #C7D2FE', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <CheckIcon sx={{ fontSize: 12, color: '#6366F1' }} />
                      </Box>
                      <Typography sx={{ color: '#374151', fontSize: '0.88rem' }}>{f}</Typography>
                    </Box>
                  ))}
                </Box>
                <Button onClick={() => navigate(s.link)} endIcon={<ArrowForwardIcon />} sx={{
                  bgcolor: '#EEF2FF', color: '#4F46E5', border: '1px solid #C7D2FE',
                  px: 3, py: 1.2, borderRadius: '8px', fontWeight: 700, textTransform: 'none', fontSize: '0.9rem',
                  '&:hover': { bgcolor: '#6366F1', color: '#FFFFFF', borderColor: '#6366F1' },
                  transition: 'all 0.25s',
                }}>
                  Explore {s.title}
                </Button>
              </Box>
              <Box sx={{ direction: 'ltr' }}>{s.visual}</Box>
            </Box>
          </Container>
        </Box>
      ))}
    </Box>
  );
};

export default Solutions;
